import http from "../http-common";

class CommuneService{
    getByVille(idville) {
        return http.get("/widget_liste_commune.php?idville=" + idville);
    }
}

export default new CommuneService();